module.exports = __webpack_public_path__ + "static/media/Nichwagh-Ridge-First-Amended.781c4895.pdf";